module.exports = __webpack_public_path__ + "static/media/price-yellow.3fce84d9.svg";